import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, focusManager } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { DateProvider } from './context/DateContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/custom.scss';

// 모바일 웹앱을 위한 focusManager 커스터마이징
// Page Visibility API를 사용하여 화면 복귀 감지 (다른 앱 전환, 화면 꺼짐/켜짐)
focusManager.setEventListener((handleFocus) => {
  const handleVisibilityChange = () => {
    handleFocus(document.visibilityState === 'visible');
  };

  // visibilitychange: 화면 켜짐/꺼짐, 앱 전환 감지 (모바일 최적화)
  document.addEventListener('visibilitychange', handleVisibilityChange);

  // focus: 기존 브라우저 탭 전환 (데스크톱 호환성)
  window.addEventListener('focus', () => handleFocus(true));

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('focus', () => handleFocus(true));
  };
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true, // 화면 복귀 시 자동 새로고침
      staleTime: 0, // 탭 이동 시 항상 새로고침
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <DateProvider>
            <App />
            <Toaster
            position="top-center"
            toastOptions={{
              duration: 2000,
              style: {
                borderRadius: '8px',
                background: '#333',
                color: '#fff',
              },
            }}
            />
          </DateProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
